var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "c-nav c-nav--illustrations" }, [
    _c(
      "button",
      {
        staticClass: "c-btn c-btn--invisible has-icon c-btn--vert-center",
        attrs: { type: "button", "aria-label": "Vis forrige illustrasjon" },
        on: {
          click: function ($event) {
            return _vm.changeIllustration(-1)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.changeIllustration(-1)
          },
        },
      },
      [_c("icon-left", { staticClass: "c-nav__icon c-nav__icon--big" })],
      1
    ),
    _vm._v(" "),
    _c("span", [
      _vm._v(
        "\n    " +
          _vm._s(_vm.index + 1) +
          "/" +
          _vm._s(_vm.illustrationIds.length) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "c-btn c-btn--invisible has-icon c-btn--vert-center",
        attrs: { type: "button", "aria-label": "Vis neste illustrasjon" },
        on: {
          click: function ($event) {
            return _vm.changeIllustration(1)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.changeIllustration(1)
          },
        },
      },
      [_c("icon-right", { staticClass: "c-nav__icon c-nav__icon--big" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }